import { createAction } from 'redux-actions'

const ns = 'uploads'

export const SET_PHOTOS = createAction(`${ns}/setPhotos`)
export const CLEAR_PHOTOS = createAction(`${ns}/clearPhotos`)
export const PUSH_PHOTO_TO_CLOUD = createAction(`${ns}/sendPhotoToS3`)
